import MDButton from "../../components/MDButton";
import {formatCurrency} from "../common/Utils";
import {Col, Container, Row} from "react-bootstrap";
import {ButtonGroup, Grid, InputAdornment} from "@mui/material";
import Avatar from "@mui/material/Avatar";
import React, {useContext, useEffect, useState} from "react";
import TextField from "@mui/material/TextField";
import MDInput from "../../components/MDInput";
import Divider from "@mui/material/Divider";
import {AccessAlarm, Add, AllInclusive, People, RefreshOutlined, Remove, RemoveCircle} from "@mui/icons-material";
import MDBox from "../../components/MDBox";
import CafeGroups from "../cart/CafeGroups";
import ToggleDetails from "../common/ToggleDetail";
import Checkbox from "@mui/material/Checkbox";
import MembershipPerks from "../perks/MembershipPerks";
import {DesktopDatePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import {AppContext} from "../../lib/AppContext";
import LockedAccountForm from "../form/LockedAccountForm";
import LockPersonIcon from "@mui/icons-material/LockPerson";
import {CONSTANTS} from "../common/constants";

export default function InventoryModalBody({
                                             inventory,
                                             quantity,
                                             addToCart,
                                             itemCallback,
                                             cafeCallback,
                                             membershipCallback,
                                             giftCardRecipientCallback,
                                             client,
                                             internalCallback,
                                             giftCardError
                                           }) {

  const [context, setContext] = useContext(AppContext);

  const [siblingRenderIndex, setSiblingRenderIndex] = useState(1);
  const [giftCardAmount, setGiftCardAmount] = useState(0);
  const [formInvalid, setFormInvalid] = useState(false);
  const [giftCardRecipientName, setGiftCardRecipientName] = useState();
  const [giftCardInternal, setGiftCardInternal] = useState(false);

  const [giftCardTokenKey, setGiftCardTokenKey] = useState();
  const [giftCardTokenValue, setGiftCardTokenValue] = useState();

  const [giftCardRecipientEmail, setGiftCardRecipientEmail] = useState();
  const [giftCardRecipientMessage, setGiftCardRecipientMessage] = useState();
  const [giftCardRecipientSendDate, setGiftCardRecipientSendDate] = useState();
  const [giftCardDeliverFuture, setGiftCardDeliverFuture] = useState(false);
  const [giftCardPhysical, setGiftCardPhysical] = useState(false);

  const [cafeItem, setCafeItem] = useState(inventory?.inventoryType?.cafeItem || false);
  const [cafeOptions, setCafeOptions] = useState();
  const [siblingQuantity, setSiblingQuantity] = useState(0);
  const [membershipMemberAdults, setMembershipMemberAdults] = useState([]);
  const [membershipMemberChildren, setMembershipMemberChildren] = useState([]);

  const maxQuantity = 10;

  const [adminUser, setAdminUser] = useState(false);
  useEffect(() => {
    setAdminUser(context?.sessionUser?.adminUser?.superAdmin);
  }, [context?.sessionUser]);

  const [membershipMembers, setMembershipMembers] = useState([]);
  useEffect(() => {
    let arr = [];
    for (let j in membershipMemberAdults) {
      arr.push(membershipMemberAdults[j]);
    }
    for (let j in membershipMemberChildren) {
      arr.push(membershipMemberChildren[j]);
    }
    setMembershipMembers(arr);
  }, [membershipMemberAdults, membershipMemberChildren]);

  useEffect(() => {
    if (inventory?.lockedAccount && membershipMembers?.length === 0) {
      membershipCallback({
        membershipValid: false
      })
      return;
    }
    membershipCallback({
      membershipValid: true,
      membershipMembers: membershipMembers
    })

  }, [inventory?.lockedAccount, membershipMembers]);

  const addToCartFn = (inventory) => {
    let _inv = {...inventory};
    let giftRecipient = {
      recipientName: giftCardRecipientName,
      email: giftCardRecipientEmail,
      message: giftCardRecipientMessage,
      sendDate: giftCardRecipientSendDate,
      deliverFuture: giftCardDeliverFuture,
      giftCardInternal: giftCardInternal,
      giftCardTokenKey: giftCardTokenKey,
      giftCardTokenValue: giftCardTokenValue
    }
    _inv.giftRecipient = giftRecipient;
    addToCart(_inv);
  }

  const [giftCardTabActive, setGiftCardTabActive] = useState('physical')

  useEffect(() => {
    if (inventory?.giftCard) {
      setGiftCardAmount(inventory?.minAmount);
    }
  }, [inventory]);

  const toggleAdults = (guid) => {
    setMembershipMemberAdults(prev =>
      prev.includes(guid)
        ? prev.filter(id => id !== guid)
        : [...prev, guid]
    );
  };

  const toggleChildren = (guid) => {
    setMembershipMemberChildren(prev =>
      prev.includes(guid)
        ? prev.filter(id => id !== guid)
        : [...prev, guid]
    );
  };

  return (
    <>
      <Row>
        <Col className={'col col-main'} xs={12}>
          <Container>
            <Row>

              <Grid container>
                <Grid item sm={3}>
                  <Avatar alt={inventory?.name}
                          variant="rounded"
                          sx={{width: '80%', height: 'auto'}}>
                    {inventory?.imageUrl && <img src={inventory?.imageThumbUrl || inventory?.imageUrl}
                                                 style={{width: '100%', height: 'auto'}}
                                                 alt={inventory?.name}/>}
                  </Avatar>
                </Grid>
                <Grid item sm={9}>
                  <h4 style={{
                    display: 'block',
                  }}>
                    {inventory.name}
                  </h4>

                  <div style={{
                    display: 'block',
                  }}>
                    {!inventory?.giftCard && !cafeItem && <>
                      <Col className={'col'} lg={12} md={12} sm={12} xs={12}>

                        <table className={'table table-hover'}>
                          <thead>
                          <tr>
                            <th>Price</th>
                            <th>Quantity</th>
                            <th>Total</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr>
                            <td>
                              <span
                                className={inventory?.accountType?.siblingOptionsEnabled ? 'text-decoration-line-through' : ''}>
                              {formatCurrency(inventory.price)}
                            </span>
                              {inventory?.accountType?.siblingOptionsEnabled && <>
                                <br/>
                                {formatCurrency(inventory.discountPrice)}
                              </>}
                            </td>
                            <td>
                              {quantity}
                            </td>
                            <td>
                              {formatCurrency(inventory.price * quantity)}
                            </td>
                          </tr>
                          </tbody>
                        </table>

                      </Col>
                    </>}

                    {cafeItem && <CafeGroups callback={(c) => {
                      setCafeOptions(c)
                    }}
                                             quantity={quantity}
                                             cafeCallback={cafeCallback}
                                             inventory={inventory}
                                             groups={inventory?.cafeGroups}/>
                    }

                    {inventory?.siblingMembership && <>
                      <Row>

                        <Divider/>
                        <div p={1} style={{
                          margin: '0 auto',
                          padding: '0 12px 20px 12px',
                          background: inventory.includeSiblingMembership ? '#fff' : '#efefef'
                        }}>
                          <Grid container>
                            <Grid item sm={12}>
                              <h6>
                                <label htmlFor="checkboxMembership">
                                  <Checkbox
                                    id="checkboxMembership"
                                    name="checkboxMembership"
                                    checked={inventory?.includeSiblingMembership || false}
                                    onChange={(e) => {
                                      inventory.includeSiblingMembership = e.target.checked;
                                      let q = 0;
                                      if (!e.target.checked) {
                                        setSiblingQuantity(0);
                                        q = 0;
                                      } else {
                                        setSiblingQuantity(1);
                                        q = 1;
                                      }
                                      setSiblingRenderIndex(siblingRenderIndex + 1);
                                      inventory.siblingQuantity = q;
                                      itemCallback(inventory.includeSiblingMembership ? 'Package ' : '', q)
                                    }}
                                  /> Sibling Add-On
                                </label>
                              </h6>
                              <p>Price: {formatCurrency(inventory?.siblingMembership.price)}</p>

                              <div className={'d-block'}>
                                {siblingRenderIndex > 0 &&
                                  <>
                                    <MDInput type="text" step="1" required
                                             onChange={(e) => {
                                               setSiblingQuantity(e.target.value);
                                               itemCallback(inventory.includeSiblingMembership ? 'Package ' : '', parseInt(e.target.value))
                                             }}
                                             InputProps={{
                                               readOnly: true,
                                               startAdornment: <InputAdornment position="start"
                                                                               className={'cursor-pointer'}
                                                                               onClick={(e) => {
                                                                                 let _q = siblingQuantity - 1;
                                                                                 if (_q >= 0) {
                                                                                   setSiblingQuantity(_q);
                                                                                 } else {
                                                                                   _q = 0;
                                                                                 }
                                                                                 inventory.siblingQuantity = _q;
                                                                                 itemCallback(inventory.includeSiblingMembership ? 'Package ' : '', _q)
                                                                               }}>
                                                 <Remove/>
                                               </InputAdornment>,
                                               endAdornment: <InputAdornment position="end"
                                                                             className={'cursor-pointer'}
                                                                             onClick={(e) => {
                                                                               let _q = siblingQuantity;
                                                                               let _newQ = _q + 1;
                                                                               if (_newQ <= maxQuantity) {
                                                                                 setSiblingQuantity(_newQ);
                                                                                 inventory.includeSiblingMembership = true;
                                                                                 inventory.siblingQuantity = _newQ;
                                                                                 setSiblingRenderIndex(siblingRenderIndex + 1);
                                                                                 itemCallback(inventory.includeSiblingMembership ? 'Package ' : '', _newQ)
                                                                               }
                                                                             }}>
                                                 <Add/>
                                               </InputAdornment>,
                                             }}
                                             value={siblingQuantity || 0}
                                             autoComplete="off"
                                             className="form-control" id="quantity"
                                             label="Quantity"
                                             style={{width: '125px'}}/>

                                  </>
                                }
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                      </Row>
                    </>}

                    {inventory?.lockedAccount && <LockedAccountForm inventory={inventory}
                                                                    client={client}
                                                                    siblingQuantity={siblingQuantity + 1}
                                                                    callback={(cb) => {
                                                                      setMembershipMembers(cb?.membershipMembers);
                                                                    }}
                    />}

                    <h5>Details
                      {adminUser && <>
                        {inventory?.giftCard &&
                          <label htmlFor={'giftCardInternal'} className={'pull-right'}><small>Internal</small>&nbsp;
                            <Checkbox defaultChecked={false}
                                      onChange={(e) => {
                                        setGiftCardInternal(!giftCardInternal);
                                        giftCardRecipientCallback(e);
                                      }}
                                      name="giftCardInternal"
                                      id="giftCardInternal"/>
                          </label>
                        }
                      </>}
                    </h5>

                    <div style={{
                      clear: 'both',
                      marginTop: '10px',
                      whiteSpace: 'pre-wrap',
                      fontSize: '0.875rem',
                      marginBottom: '8px'
                    }}>
                      <ToggleDetails text={inventory?.desc} limit={35}/>
                    </div>
                    {inventory?.accountType?.siblingOptionsEnabled && <p>
                      <b><small>Discount Sibling Rate</small></b>
                    </p>}
                  </div>

                  <MembershipPerks inventory={inventory}/>

                  {inventory?.giftCard && <div style={{
                    width: '100%',
                    padding: '15px 0'
                  }}>
                    {inventory?.minAmount === inventory?.maxAmount && <>
                      <div style={{
                        display: 'block',
                        margin: '10px 0'
                      }}>
                        <h5 htmlFor="name">Price</h5>
                        <p>
                          {formatCurrency(giftCardAmount)}
                        </p>
                      </div>
                    </>}
                    {inventory?.minAmount !== inventory?.maxAmount && <>
                      <TextField type="number" step="1" required
                                 min={inventory?.minAmount}
                                 max={inventory?.maxAmount}
                                 onChange={(e) => {
                                   let target = parseFloat(e.target.value);
                                   if (target < parseFloat(inventory?.minAmount)) {
                                     setFormInvalid(true);
                                     setGiftCardAmount(target);
                                   } else if (target > parseFloat(inventory?.maxAmount)) {
                                     setFormInvalid(true);
                                   } else {
                                     setFormInvalid(false);
                                     setGiftCardAmount(target);
                                   }
                                   giftCardRecipientCallback(e)
                                 }}
                                 InputProps={{
                                   startAdornment: <AttachMoneyIcon/>,
                                   inputProps: {
                                     min: parseFloat(inventory?.minAmount),
                                     max: parseFloat(inventory?.maxAmount),
                                     step: 0.01
                                   }
                                 }}

                                 value={giftCardAmount}
                                 autoComplete="off"
                                 name="giftCardAmount"
                                 className="form-control pull-left" id="giftCardAmount"
                                 label="Gift Card Amount"
                                 style={{width: '250px'}}/>
                      <p style={{
                        marginTop: '5px',
                        clear: 'both'
                      }}>Enter gift card value between&nbsp;
                        {formatCurrency(inventory?.minAmount)} - {formatCurrency(inventory?.maxAmount)}
                      </p>
                    </>
                    }

                    <div style={{
                      marginTop: '15px',
                      width: '100%'
                    }}>
                      <ButtonGroup>
                        <MDButton size="small"
                                  key={'physical'}
                                  style={{
                                    color: giftCardTabActive === 'physical' ? '#fff' : '#111',
                                    background: giftCardTabActive === 'physical' ? '#111' : '#fff',
                                    borderColor: '#111'
                                  }}
                                  onClick={(e) => {
                                    setGiftCardTabActive('physical')
                                    giftCardRecipientCallback({
                                      giftCardType: 'physical'
                                    })
                                  }}>
                          Physical Gift Card
                        </MDButton>
                        <MDButton key={'egift'}
                                  style={{
                                    color: giftCardTabActive === 'egift' ? '#fff' : '#111',
                                    background: giftCardTabActive === 'egift' ? '#111' : '#fff',
                                    borderColor: '#111'
                                  }}
                                  onClick={(e) => {
                                    setGiftCardTabActive('egift')
                                    giftCardRecipientCallback({
                                      giftCardType: 'egift'
                                    })
                                  }}>
                          E-Gift Card
                        </MDButton>
                        <MDButton key={'egift'}
                                  style={{
                                    color: giftCardTabActive === 'personal' ? '#fff' : '#111',
                                    background: giftCardTabActive === 'personal' ? '#111' : '#fff',
                                    borderColor: '#111'
                                  }}
                                  onClick={(e) => {
                                    setGiftCardTabActive('personal')
                                    giftCardRecipientCallback({
                                      giftCardType: 'personal'
                                    })
                                  }}>
                          For Self
                        </MDButton>
                      </ButtonGroup>
                      {giftCardTabActive === 'physical' && <div className={'my-4'}>
                        <Row>
                          <Col xs={12} sm={12}>

                            <MDInput type="text"
                                     variant="outlined"
                                     InputLabelProps={{shrink: true}}
                                     autoComplete={"off"}
                                     defaultValue={giftCardTokenValue}
                                     onChange={(e) => {
                                       setGiftCardTokenValue(e.target.value)
                                       giftCardRecipientCallback(e)
                                     }}
                                     required={giftCardPhysical}
                                     className="form-control"
                                     name="giftCardTokenValue"
                                     id="giftCardTokenValue"
                                     label="Enter Gift Card Number"
                                     placeholder="Gift Card Number"
                            />
                          </Col>
                        </Row>
                        {giftCardError && <p className={'mt-2'}><b>{giftCardError}</b></p>}
                      </div>}
                    </div>

                    {giftCardTabActive === 'egift' && <>
                      <h6>
                        Gift Card Recipient
                      </h6>

                      <div style={{
                        marginTop: '15px',
                        width: '100%'
                      }}>
                        <MDInput type="text"
                                 variant="outlined"
                                 InputLabelProps={{shrink: true}}
                                 autoComplete="gift-card-recipient-name"
                                 defaultValue={giftCardRecipientName}
                                 onChange={(e) => {
                                   setGiftCardRecipientName(e.target.value)
                                   giftCardRecipientCallback(e)
                                 }}
                                 className="form-control"
                                 name="giftCardRecipientName"
                                 id="giftCardRecipientName"
                                 label="Enter recipient name"
                                 placeholder="Recipient Name"
                        />
                      </div>

                      <div style={{
                        marginTop: '15px',
                        width: '100%'
                      }}>
                        <MDInput type="email"
                                 variant="outlined"
                                 InputLabelProps={{shrink: true}}
                                 autoComplete="gift-card-recipient-email"
                                 defaultValue={giftCardRecipientEmail}
                                 onChange={(e) => {
                                   setGiftCardRecipientEmail(e.target.value)
                                   giftCardRecipientCallback(e)
                                 }}
                                 className="form-control"
                                 name="giftCardRecipientEmail"
                                 id="giftCardRecipientEmail"
                                 label="Enter recipient email"
                                 placeholder="Recipient Email"
                        />
                      </div>

                      <div style={{
                        marginTop: '15px',
                        width: '100%'
                      }}>
                        <h6>Personal Message</h6>
                        <textarea type="text"
                                  defaultValue={giftCardRecipientMessage}
                                  onChange={(e) => {
                                    setGiftCardRecipientMessage(e.target.value)
                                    giftCardRecipientCallback(e)
                                  }}
                                  autoComplete="off"
                                  maxLength={255}
                                  name="giftCardRecipientMessage"
                                  className="form-control" id="giftCardRecipientMessage"
                                  placeholder="Enter Message"/>
                      </div>

                      <div style={{
                        marginTop: '15px',
                        width: '100%'
                      }}>
                        <h6>Future Gift <Checkbox defaultChecked={false}
                                                  onChange={(e) => {
                                                    setGiftCardDeliverFuture(!giftCardDeliverFuture);
                                                    giftCardRecipientCallback(e);
                                                  }}
                                                  name="giftCardDeliverFuture"
                                                  id="giftCardDeliverFuture"/></h6>
                        <div className="form-group">
                          <label htmlFor="billingEndDate">Choose Scheduled Delivery Date</label>

                          <div className={'input-group d-block'}>
                            <DesktopDatePicker
                              disabled={!giftCardDeliverFuture}
                              slotProps={{
                                actionBar: {
                                  actions: ['today'],
                                },
                              }}
                              name={'giftCardRecipientSendDate'}
                              value={dayjs(giftCardRecipientSendDate)}
                              minDate={dayjs()}
                              onChange={(e) => {
                                setGiftCardRecipientSendDate(new Date(e.$d));
                                let _e = {
                                  target: {
                                    name: 'giftCardRecipientSendDate',
                                    value: new Date(e.$d)
                                  }
                                }
                                giftCardRecipientCallback(_e);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </>}

                  </div>}


                  <div>
                    <MDBox mt={1}>
                      {inventory?.accountType && <>
                        <dl className={'row'}>
                          {inventory?.accountType?.recurring &&
                            <>
                              <dd className={'col col-sm col-sm-12'}>
                                <small><RefreshOutlined/> Recurring
                                  {inventory.accountType?.recurrencePattern === CONSTANTS.RECURRENCE_TYPES.TIME_BASED_RECURRING && ' every ' +
                                    inventory.accountType.membershipTimeDays + ' Days'}
                                </small>
                              </dd>

                              <dd className={'col col-sm col-sm-12'} style={{
                                display: !inventory?.accountType?.minMembershipMonths || !inventory?.accountType?.minimumCancellationDays ? 'none' : 'block'
                              }}>
                                <small><RemoveCircle/> Cancel at any time</small>
                              </dd>
                              {inventory?.minimumMembership &&
                                <dd className={'col col-sm col-sm-12'}>
                                  <small><LockPersonIcon/> Minimum {inventory?.minMembershipMonths} {inventory?.minMembershipMonths === 1 ? 'Month' : 'Months'}
                                  </small>
                                </dd>
                              }

                              {inventory?.minimumCancellationDays &&
                                <dd className={'col col-sm col-sm-12'}>
                                  <small><AccessAlarm/>&nbsp;{inventory?.minimumCancellationDays} {inventory?.minimumCancellationDays === 1 ? 'Day' : 'Days'} Cancellation
                                    Notice</small>
                                </dd>
                              }
                            </>
                          }
                          {inventory?.accountType?.unlimitedVisits &&
                            <dd className={'col col-sm col-sm-12'}>
                              <small><AllInclusive/> Unlimited Visits</small>
                            </dd>
                          }
                          {inventory?.siblingMembership && <>
                            <dd className={'col col-sm col-sm-6'}>
                              <small><People/> Sibling Rate {formatCurrency(inventory?.siblingMembership?.price)}
                              </small>
                            </dd>
                          </>}
                        </dl>
                      </>}
                    </MDBox>
                  </div>
                </Grid>
              </Grid>


            </Row>

          </Container>
        </Col>
      </Row>


      {addToCart && <MDButton variant="gradient"
                              color="secondary"
                              size="small"
                              className={'pull-right mt-n1'}
                              onClick={(e) => {
                                addToCartFn(inventory);
                              }}>Add to Cart
      </MDButton>}
    </>
  )
}